export const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
export const CLARITY_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;
export const CONSENT_STORAGE_KEY = 'wedigo_cookie_consent';
